import React from "react";
import Icon from "@ant-design/icons";


const TimeRecordsSvg = () => (
    <svg
        fill="currentColor"
        width="1em"
        height="1em"
        viewBox="0 0 27 27"
    >
        <path
            transform="translate(5.0003 5.0001)"
            fillRule="evenodd"
            d="M9.3336992 0C14.480615 0 18.667887 4.1872921 18.667887 9.3342333C18.667887 14.481174 14.480615 18.668467 9.3336992 18.668467C4.1872716 18.668467 0 14.481174 0 9.3342333C0 4.1872921 4.1872716 0 9.3336992 0ZM9.3336992 1.2209272C4.8602433 1.2209272 1.2209213 4.8607554 1.2209213 9.3342333C1.2209213 13.807711 4.8602433 17.447538 9.3336992 17.447538C13.807155 17.447538 17.446966 13.807711 17.446966 9.3342333C17.446966 4.8607554 13.807155 1.2209272 9.3336992 1.2209272ZM9.2570744 2.0923762C9.5940485 2.0923762 9.8675346 2.365864 9.8675346 2.7028399V8.8724298L14.113899 11.609261C14.397641 11.791911 14.479198 12.169421 14.296549 12.453165C14.179829 12.634351 13.983016 12.733002 13.782785 12.733002C13.669484 12.733002 13.554717 12.701258 13.452648 12.635816L8.9264488 9.7187767C8.7521009 9.606451 8.6466131 9.4130564 8.6466131 9.2054987V2.7028399C8.6466131 2.365864 8.9196119 2.0923762 9.2570744 2.0923762Z"
        />
    </svg>
);

const TimeRecordsIcon = ({ className }) => (
    <Icon component={ TimeRecordsSvg } className={ className } />
);

export default TimeRecordsIcon;
